import { UserSettings } from "../../utilities/types";
import { BaseDataModel } from "./base";

export interface Contact extends BaseDataModel {
	name: string;
	firstName: string;
	lastName: string;
	email: string;

	isSalesperson: boolean;

	companyIds: string[];
	companyIdsDm: string[];
	companyIdsAll: string[];
	branchIds: string[];
	salespersonBranchIds: string[];
	proagricaAuth: string;
	portalSettings: UserSettings;

	mobilePhone: string;
}

export function newSalespersonContact(id: string, name: string, firstName?: string, lastName?: string): Contact {
	return {
		id: id,
		name: name,
		firstName: firstName ?? "",
		lastName: lastName ?? "",
		email: "",

		isSalesperson: true,

		companyIds: [],
		companyIdsDm: [],
		companyIdsAll: [],
		branchIds: [],
		salespersonBranchIds: [],
		proagricaAuth: "",
		portalSettings: { views: [] },

		mobilePhone: "",
	};
}
